export default __webpack_public_path__ + "static/media/ticket40.a6936373.jpg";